import { isDefined } from "@clipboard-health/util-ts";
import { BookabilityUnmetCriteria } from "@src/appV2/OpenShifts/ShiftAction";
import { isFuture } from "date-fns";

import { type ModalShiftAuctionData } from "../types";

/**
 * Determines if a worker can place a bid on a shift auction.
 *
 * A bid is allowed when:
 * 1. A shift auction exists and hasn't ended
 * 2. The only unmet criterion is SHIFT_AUCTION_ACTIVE (expected for active auctions)
 */
export function canPlaceBidOnAuction(params: {
  shiftAuction: ModalShiftAuctionData | undefined;
  bookabilityUnmetCriteria: BookabilityUnmetCriteria[];
}): boolean {
  const { shiftAuction, bookabilityUnmetCriteria } = params;

  return (
    isDefined(shiftAuction) &&
    bookabilityUnmetCriteria.length === 1 &&
    bookabilityUnmetCriteria[0] === BookabilityUnmetCriteria.SHIFT_AUCTION_ACTIVE &&
    isFuture(shiftAuction.attributes.endTime)
  );
}
